import { render, staticRenderFns } from "./inventory-bonuses-form.vue?vue&type=template&id=b3c33a28"
import script from "./inventory-bonuses-form.vue?vue&type=script&lang=js"
export * from "./inventory-bonuses-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports